import { render } from "./TermAssurancePlanSelection.vue?vue&type=template&id=89ff8378&scoped=true"
import script from "./TermAssurancePlanSelection.vue?vue&type=script&lang=js"
export * from "./TermAssurancePlanSelection.vue?vue&type=script&lang=js"

import "./TermAssurancePlanSelection.vue?vue&type=style&index=0&id=89ff8378&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89ff8378"]])

export default __exports__